module.exports = __webpack_public_path__ + "static/media/Logo-Color.5f791551.png";